export const detectBrandName = (detectedBrandName, prompt) => {
  const brandNames = detectedBrandName
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .split(',').map(s => s.trim()).join('(?=\\W|^|$)|(?<=\\W|^|$)');
  const brandNameRegex = new RegExp(`(?<=\\W|^|$)${brandNames}(?=\\W|^|$)`, 'i');
  return brandNameRegex.test(prompt);
};
